import React from 'react';
import type { FC } from 'react';
import { styled } from '@material-ui/core';

interface Props {
  readonly children: string;
  readonly show: boolean;
}

const StyledGroupName = styled('div')({
  color: 'rgba(0, 0, 0, 0.6);',
  fontSize: '12px',
  letterSpacing: '1.5px'
});

const SidebarGroupName : FC<Props> = ({ children, show }) => {
  if (show) {
    return (
      <StyledGroupName>
        { children }
      </StyledGroupName>
    );
  } else {
    return null;
  }
};

export default SidebarGroupName;
